import { render, staticRenderFns } from "./BDatatable.vue?vue&type=template&id=3352fdbe"
import script from "./BDatatable.vue?vue&type=script&lang=js"
export * from "./BDatatable.vue?vue&type=script&lang=js"
import style0 from "./BDatatable.vue?vue&type=style&index=0&id=3352fdbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports